import {
  SHOW_ALERT,
  SHOW_SNACKBAR,
  CLEAR_ALERT,
  CLEAR_SNACKBAR,
  SHOW_CONFIRMATION,
} from "../../data/constants";

// eslint-disable-next-line
export default (state, action) => {
  switch (action.type) {
    case SHOW_ALERT:
      return {
        ...state,
        message: action.payload.message,
        title: action.payload.title,
        ui: "dialog",
        show: true,
        alertType: action.payload.alertType,
      };
    case SHOW_SNACKBAR:
      return {
        ...state,
        message: action.payload.message,
        messageType: action.payload.messageType,
        ui: "snack",
        show: true,
      };
    case SHOW_CONFIRMATION:
      return {
        ...state,
        message: action.payload.message,
        title: action.payload.title,
        messageType: action.payload.messageType,
        alertType: action.payload.alertType,
        submitAction: action.payload.submitAction,
        ui: "confirm",
        show: true,
      };
    case CLEAR_ALERT:
      return {
        ...action.payload,
        show: false,
      };

    default:
      return state;
  }
};
